import { ICommandeFormationWebServiceClient } from "@resources/resources";
import { CommandeFormationStore } from "./../../../../../common/store/commande-formation.store";
import { ArianeElement, ArianeStore, ModalService } from "@digicerba/common";
import { FormBuilder, FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import { Component, ViewChild } from "@angular/core";
import {
  CiviliteEnum,
  FormationDto,
  IFormationWebServiceClient,
  OrganismeCommanditaireDto,
  SaveParticipantFormationDto
} from "@common/resources/resources";
import { Router } from "@angular/router";
import { ModalDialog } from "@common/utils/dialog/modal/modal.component";
import { AsiDialogService } from "@asi-ngtools/lib";

@Component({
  selector: 'inscription-component',
  templateUrl: './inscription.component.html',
  host: { 'class': 'page' }
})
export class InscriptionComponent {

  currentlyOpened: number;
  enCreation: boolean = false;
  laboForm: FormGroup;
  participantForm: FormGroup;

  @ViewChild("formLabo", { read: FormGroupDirective }) laboratoire: FormGroupDirective;

  listFormationsCompletes: Array<FormationDto>;

  constructor(private asiDialogService: AsiDialogService, private modalService: ModalService, private router: Router, private arianeStore: ArianeStore,
    private commandeFormationStore: CommandeFormationStore, private fb: FormBuilder, private formationWebServiceClient: IFormationWebServiceClient,
    private commandeFormationWebServiceClient: ICommandeFormationWebServiceClient) {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
      {
        libelle: "Inscription : Participants",
        route: "/inscription"
      }
    ];

    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    // si on a pas de formation dans le commande store... on retourne en page 0
    if (this.commandeFormationStore.countFormations() == 0) {
      this.router.navigate(['cerba/liste-formations']);
    } else {
      // initialisation du formulaire labo
      this.laboForm = this.fillLaboForm(this.commandeFormationStore.getOrganismeCommanditaire());

      // initialisation du formation participants
      let participants = this.commandeFormationStore.getParticipantFormations();
      this.participantForm = this.fillParticipantForm(participants.length > 0 ? participants[participants.length - 1] : null);

      this.currentlyOpened = -1;
      if (participants != null && participants.length == 1 && participants[0].nom == null) {
        this.currentlyOpened = 0;
      }
      this.listFormationsCompletes = [];
    }
  }

  fillLaboForm(organismeCommanditaire: OrganismeCommanditaireDto): FormGroup {
    return this.fb.group({
      nom: [organismeCommanditaire != null ? organismeCommanditaire.nom : null, Validators.required],
      adresse: [organismeCommanditaire != null ? organismeCommanditaire.adresse : null, Validators.required],
      codePostal: [organismeCommanditaire != null ? organismeCommanditaire.codePostal : null, Validators.required],
      ville: [organismeCommanditaire != null ? organismeCommanditaire.ville : null, Validators.required],
      telephone: [organismeCommanditaire != null ? organismeCommanditaire.telephone : null, Validators.required],
      fax: [organismeCommanditaire != null ? organismeCommanditaire.fax : null, Validators.required],
      email: [organismeCommanditaire != null ? organismeCommanditaire.email : null, [Validators.required, Validators.email]]
    });
  }

  fillParticipantForm(participantFormation: SaveParticipantFormationDto): FormGroup {
    if (participantFormation == null) {
      this.currentlyOpened = this.commandeFormationStore.countParticipantFormations() - 1;
    }
    let result = this.fb.group({
      civilite: [participantFormation != null ? participantFormation.civilite : null, Validators.required],
      name: [participantFormation != null ? participantFormation.nom : null, Validators.required],
      prenom: [participantFormation != null ? participantFormation.prenom : null, Validators.required],
      fonction: [participantFormation != null ? participantFormation.fonction : null, Validators.required],
      adeli: participantFormation != null ? participantFormation.rppsOrAdeli : null,
      telephone: participantFormation != null ? participantFormation.telephone : null,
      email: [participantFormation != null ? participantFormation.email : null, [Validators.required, Validators.email]],
      ogdpc: [participantFormation != null ? participantFormation.ogdpc : null, Validators.required],
      organisme: participantFormation != null ? participantFormation.organismePriseEnCharge : null
    });

    result.controls.ogdpc.valueChanges.subscribe(d => {
      if (d == false) {
        this.participantForm.controls.organisme.setValidators([Validators.required]);
        this.participantForm.controls.organisme.updateValueAndValidity();
      } else {
        this.participantForm.controls.organisme.clearValidators();
        this.participantForm.controls.organisme.updateValueAndValidity();
      }
    });
    return result;
  }

  countParticipants(): number {
    return this.commandeFormationStore.countParticipantFormations();
  }

  getParticipants(): Array<SaveParticipantFormationDto> {
    return this.commandeFormationStore.getParticipantFormations();
  }

  getFormationsSelectionnees(): Array<FormationDto> {
    return this.commandeFormationStore.getFormations();
  }

  annuler() {
    this.modalService.openConfirmDialog("MODAL.ANNULATION.title", "MODAL.ANNULATION.message", "MODAL.ANNULATION.confirm", "MODAL.ANNULATION.cancel")
      .onDialogClose().subscribe(() => {
        this.commandeFormationStore.emptySaveCommandeFormation();
        this.router.navigate(["/cerba/liste-formations"]);
      });
  }

  nouveauParticipant() {
    let formationIds = this.commandeFormationStore.getSaveCommandeFormation().formationIds;
    return this.formationWebServiceClient.computeMultiplePlaceDisponibles(formationIds).subscribe(data => {
      this.updateFormationsCompletesNouveauParticipant(data);

      if (this.listFormationsCompletes.length > 0) {
        let asiDialog = this.asiDialogService.fromComponent(ModalDialog, null);
        asiDialog.getComponent().formations = this.listFormationsCompletes;
      } else {
        let newParticipant = new SaveParticipantFormationDto();
        this.commandeFormationStore.addParticipantFormation(newParticipant);
        this.participantForm = this.fillParticipantForm(newParticipant);
        this.currentlyOpened = this.commandeFormationStore.countParticipantFormations() - 1;
        this.enCreation = true;
      }
    });
  }

  nextStep() {
    let formationIds = this.commandeFormationStore.getSaveCommandeFormation().formationIds;
    return this.formationWebServiceClient.computeMultiplePlaceDisponibles(formationIds).subscribe(data => {
      this.updateFormationsCompletesNextStep(data);

      console.log("Formations completes:" + this.listFormationsCompletes);
      if (this.listFormationsCompletes.length > 0) {
        let asiDialog = this.asiDialogService.fromComponent(ModalDialog, null);
        asiDialog.getComponent().formations = this.listFormationsCompletes;
      } else {
        this.validCommandeFormation(true);
      }
    });
  }

  validationPlacesFormations() {
    let result: Array<FormationDto> = [];
    this.listFormationsCompletes.forEach(f => {
      if (f.nombrePlacesReservees + this.commandeFormationStore.countParticipantFormations() > f.nombrePlaces) {
        result.push(f);
      }
    });
    return result;
  }

  addParticipant() {
    this.validCommandeFormation(false);
  }

  enregistrerParticipant() {
    this.validCommandeFormation(false)
    this.enCreation = false;
  }


  validCommandeFormation(gotoRecap: boolean) {

    if (this.countParticipants() < 2) {
      if (this.laboratoire) {
        this.laboratoire.ngSubmit.emit();
      }
    }

    if (this.laboForm.valid && this.participantForm.valid) {

      if (this.commandeFormationStore.hasCommandeFormation()) {
        this.commandeFormationStore.emptyCommandeFormation(true);
      }

      this.fillOrganismeCommanditaire();

      let previousParticipant = this.createParticipantFormation();
      this.commandeFormationStore.setParticipantFormation(previousParticipant, this.currentlyOpened);

      if (gotoRecap) {
        this.router.navigate(['cerba/recap-inscription']);
      }
      this.currentlyOpened = -1;
    }
  }

  updateFormationsCompletesNouveauParticipant(data: Array<number>) {
    this.listFormationsCompletes = [];
    data.forEach((item, index) => {
      let formation = this.commandeFormationStore.getFormation(index);
      if (item - this.commandeFormationStore.countParticipantFormations() <= 0) {
        this.listFormationsCompletes.push(formation);
      }
    });
  }

  updateFormationsCompletesNextStep(data: Array<number>) {
    this.listFormationsCompletes = [];
    data.forEach((item, index) => {
      let formation = this.commandeFormationStore.getFormation(index);
      if (item - this.commandeFormationStore.countParticipantFormations() < 0) {
        this.listFormationsCompletes.push(formation);
      }
    });
  }

  fillOrganismeCommanditaire() {
    let organisme = new OrganismeCommanditaireDto();
    organisme.nom = this.laboForm.value.nom;
    organisme.adresse = this.laboForm.value.adresse;
    organisme.codePostal = this.laboForm.value.codePostal;
    organisme.ville = this.laboForm.value.ville;
    organisme.telephone = this.laboForm.value.telephone;
    organisme.fax = this.laboForm.value.fax;
    organisme.email = this.laboForm.value.email;
    this.commandeFormationStore.setOrganismeCommanditaire(organisme);
  }

  createParticipantFormation(): SaveParticipantFormationDto {
    let previousParticipant = new SaveParticipantFormationDto;

    previousParticipant.civilite = <CiviliteEnum>this.participantForm.value.civilite;
    previousParticipant.nom = this.participantForm.value.name;
    previousParticipant.prenom = this.participantForm.value.prenom;
    previousParticipant.fonction = this.participantForm.value.fonction;
    previousParticipant.rppsOrAdeli = this.participantForm.value.adeli;
    previousParticipant.telephone = this.participantForm.value.telephone;
    previousParticipant.email = this.participantForm.value.email;
    previousParticipant.ogdpc = this.participantForm.value.ogdpc;
    previousParticipant.organismePriseEnCharge = this.participantForm.value.organisme;

    return previousParticipant;
  }

  isOgdpc() {
    return this.participantForm.value.ogdpc == false ? this.participantForm.value.ogdpc : true;
  }

  open(i: number) {
    this.currentlyOpened = i;
    let saveParticipantFormation = this.commandeFormationStore.getParticipantFormation(i);
    this.participantForm = this.fillParticipantForm(saveParticipantFormation);
  }

  close(i: number) {
    if (i == this.commandeFormationStore.countParticipantFormations() - 1) {
      if (this.participantForm.valid && !this.enCreation) {
        this.currentlyOpened = -1;
      } else {
        this.commandeFormationStore.removeParticipantFormation(i);
        this.currentlyOpened = -1;
        this.participantForm.reset();
        this.enCreation = false;
      }
    }
    else {
      this.currentlyOpened = -1;
    }
  }

  isOpen(i: number): boolean {
    return i == this.currentlyOpened;
  }

  enEdition(): boolean {
    return this.currentlyOpened != -1;
  }

  delete(i: number) {
    this.commandeFormationStore.removeParticipantFormation(i);
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/commande/inscription/inscription.component.ts